import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {useViewAction} from '../../../state/views/hooks';
import * as RunSetActions from '../../../state/views/runSet/actions';
import {useRampFlagBaselineRuns} from '../../../util/rampFeatureFlags';
import {WBTableRowWithRunSetInfo} from '../../../util/tablecols';
import {
  useCurrentRunSet,
  useCurrentRunSetRef,
  useRunSelectorProjectInfo,
} from '../RunSelectorRunSetContext';
import {RowHeaderMenuOption} from './RowHeaderMenuOption';

type GetBaselineLabelOpts = {
  isAnyRunBaseline: boolean;
  isRunBaseline: boolean;
};
function getBaselineLabel({
  isAnyRunBaseline,
  isRunBaseline,
}: GetBaselineLabelOpts): string {
  if (isRunBaseline) {
    return 'Remove baseline';
  } else if (isAnyRunBaseline) {
    return 'Replace baseline';
  } else {
    return 'Set baseline';
  }
}

type RunPinningAndBaselineMenuOptions = {
  row: WBTableRowWithRunSetInfo;
};

export function RunPinningAndBaselineMenuOptions({
  row,
}: RunPinningAndBaselineMenuOptions) {
  const {entityName} = useRunSelectorProjectInfo();
  const isBaselineEnabled = useRampFlagBaselineRuns();
  const runSet = useCurrentRunSet();
  const runSetRef = useCurrentRunSetRef();
  const pinnedRunIds = runSet.pinnedRunIds || [];

  const isRunPinned = pinnedRunIds.includes(row.name) ?? false;
  const isRunBaseline = runSet.baselineRunId === row.name;
  const isAnyRunBaseline = Boolean(runSet.baselineRunId);
  const setPinnedRun = useViewAction(runSetRef, RunSetActions.setPinnedRun);
  const setBaselineRun = useViewAction(runSetRef, RunSetActions.setBaselineRun);

  // TODO: constant here
  const canPinRun = pinnedRunIds.length < 5;

  const onPinClick = () => {
    setPinnedRun(row.name, !isRunPinned);
  };
  const onBaselineClick = () => {
    setBaselineRun(isRunBaseline ? null : row.name);
  };

  const baselineLabel = getBaselineLabel({
    isAnyRunBaseline,
    isRunBaseline,
  });

  return (
    <>
      <RowHeaderMenuOption
        icon={<Icon name="pin" />}
        label={isRunPinned ? 'Unpin run' : 'Pin run'}
        onSelect={onPinClick}
        disabled={!canPinRun && !isRunPinned}
      />
      {isBaselineEnabled && (
        <RowHeaderMenuOption
          icon={<Icon name="baseline-pennant" />}
          label={baselineLabel}
          onSelect={onBaselineClick}
        />
      )}
    </>
  );
}
